import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';

const clearDataOnLogout = async (): Promise<void> => {
    try {
        await axiosInstance.post(API_ENDPOINTS.CLEAR_DATA_ON_LOGOUT(), {}, {
            withCredentials: true,
        });
    } catch (error: any) {
        if (error.response?.status !== 500) {
            throw new Error(error.response.data);
        }
        throw new Error('An unexpected error occurred. Please try again.');
    }
};

export const useClearDataOnLogout = () => useMutation({
    mutationFn: clearDataOnLogout,
});

export default useClearDataOnLogout;
